/* file description */
import { Radio } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { getModuleRecordListCache } from '@/common/asset-apis/assetModel';
import { Radio as MobileRadio, Space as MobileSpace } from 'antd-mobile';
import { RoleSelectProps } from './type';
import memo from '../memo';

export const RadioSelect: FC<RoleSelectProps> = ({
  FetchAPI,
  field,
  value,
  onChange,
  isMobile,
  disabled,
}) => {
  const { dataKey, treeId, prefilter, isFilter, label, value: fieldValue, dataType } = field?.bizConfig || {};
  const [radioData, setRadioData] = useState<any[]>([]);

  useEffect(() => {
    const params: Record<any, any> = {
      moduleID: dataKey,
      namespaceID: treeId,
      filter: isFilter ? (dataType || prefilter) : '',
    };
    getModuleRecordListCache(FetchAPI, treeId, dataKey, params).then((res: any) => {
      const { set = [] } = res || {};
      const data = set.map((item: any) => {
        const { values = [] } = item || {};
        const tLabel = values.find((v: any) => v.name === label)?.value;
        const tValue = values.find((v: any) => v.name === fieldValue)?.value;
        return {
          label: tLabel,
          value: tValue,
        };
      });
      setRadioData(data);
    });
  }, []);

  if (isMobile) {
    return (
      <>
        <MobileRadio.Group
          onChange={(val) => {
            onChange?.(val);
          }}
          value={value}
        >
          <MobileSpace wrap>
            {
          radioData.map((radio: any, index) => {
            return <MobileRadio value={radio.value} key={index}>{radio.label}</MobileRadio>;
          })
        }
          </MobileSpace>
        </MobileRadio.Group>
      </>
    );
  }

  return (
    <>
      <Radio.Group
        onChange={(val) => {
          onChange?.(val);
        }}
        value={value}
        disabled={disabled}
      >
        {
          radioData.map((radio: any, index) => {
            return <Radio value={radio.value} key={index}>{radio.label}</Radio>;
          })
        }
      </Radio.Group>
    </>
  );
};
export default memo(RadioSelect);
